import axios from "axios"
import { ClientDocumentsInterface } from "../redux/documents/client_documents.type";

/**
 * Get all Client documents
 * @param uuid
 * @param clientUuid
 */

async function getDocuments (uuid: string, clientUuid: string) {
    return axios({
        method:"GET",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/documents`
    })
}

/**
 * Create new client document
 * @param uuid
 * @param clientUuid
 * @param data
 */

async function postDocument(uuid: string, clientUuid: string, data: ClientDocumentsInterface){
    return axios({
        method:"POST",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/documents`,
        data
    })
}

/**
 * Get client document
 * @param uuid
 * @param clientUuid
 * @param documentUuid
 */

async function getDocument(uuid:String, clientUuid: string, documentUuid: string){
    return axios({
        method:"GET",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/documents/${documentUuid}`
    })
}

/**
 * Delete client document
 * @param uuid
 * @param clientUuid
 * @param documentUuid
 */

async function deleteDocument(uuid: string, clientUuid: string, documentUuid: string ){
    return axios({
        method:"DELETE",
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/documents/${documentUuid}`

    })
}

/**
 * Update existing client document
 * @param uuid
 * @param clientUuid
 * @param documentUuid
 * @param data
 */

async function patchDocument(uuid: string, clientUuid: string, documentUuid: string, data: ClientDocumentsInterface){
    return axios({
        method:"PATCH",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/documents/${documentUuid}`,
        data
    })
}

export {
    deleteDocument,
    getDocument,
    getDocuments,
    patchDocument,
    postDocument
}